import React from "react";
import { object, func, oneOf, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getSlug } from "../../utils/utils";
import Loadericon from "../load-more-button-loader/index";

import "./more.m.css";

const More = ({
  collection,
  type,
  onClick,
  text,
  sections,
  publisherAttributes,
  showButtonSpinner = false,
  domainSlug
}) => {
  const moreContentStyle = publisherAttributes.lang === "en" ? "content en-content" : "content bn-content";

  if (type === "read-more") {
    const slug = getSlug(collection, sections, domainSlug);

    return (
      <a href={slug} styleName="wrapper" className="more">
        <span styleName={moreContentStyle} className="content">
          {text}
        </span>
      </a>
    );
  } else {
    return (
      <div styleName="wrapper" className="more" onClick={onClick}>
        <span styleName={moreContentStyle} className="load-more-content">
          {text}
          {showButtonSpinner && <Loadericon />}
        </span>
      </div>
    );
  }
};

More.defaultProps = {
  type: "read-more",
  text: "Read More"
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

More.propTypes = {
  collection: object,
  onClick: func,
  type: oneOf(["read-more", "load-more"]),
  publisherAttributes: object,
  showButtonSpinner: bool,
  domainSlug: string
};

export default connect(mapStateToProps)(More);
